import axiosClient from "@/libs/axiosClient";

// GET 類會帶groupName參數
// POST 類groupName會在data中

// export const getAppProfile = (id, groupName) => {
//     return axiosClient.get(`/rest/app-profiles/${id}?groupName=${groupName}`);
// };

export const _getDashboard = (id, groupName) => {
    return axiosClient.get(`/rest/dashboard/${id}?groupName=${groupName}`);
};

export const _updateDashboard = (id, data) => {
    return axiosClient.post(`/rest/dashboard/${id}`, data);
};

export const _getObjectLog = (id, groupName) => {
    return axiosClient.get(`/rest/object-log/${id}?groupName=${groupName}`);
};

// export const _getCert = (id, groupName) => {
//     return axiosClient.get(`/rest/certs/${id}?groupName=${groupName}`);
// };

export const _getResource = (endPoint, id, groupName) => {
    return axiosClient.get(`/rest/${endPoint}/${id}?groupName=${groupName}`);
};

export const _searchResources = (searchText, groupName) => {
    let queryString = new URLSearchParams({ q: searchText, groupName }).toString();
    return axiosClient.get(`/rest/resources?${queryString}`);
};

export const _getNodeRegisterTokens = ({ groupName, nodeType }) => {
    let apiEndpoint = nodeType == "edge" ? "/rest/edgetokens" : "/rest/slbtokens"
    return axiosClient.get(apiEndpoint, { params: { groupName } })
};

export const regenerateTokens = ({ groupName, nodeType, token }) => {
    let apiEndpoint = nodeType == "edge" ? "/rest/edgetokens" : "/rest/slbtokens"
    return axiosClient.patch(`${apiEndpoint}/regenerate?groupName=${groupName}`, { token: token })
}



// WEBPACK FOOTER //
// ./src/api/rest/index.js